import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";

const GET_ORDER_STATUS = `orders`

export const FetchOrderStatus = createAsyncThunk(
  "FetchOrderStatus",
  async ({ page, limit }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${GET_ORDER_STATUS}?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);




